module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "iam"
  }, [_c('bacon', {
    attrs: {
      "title": "I am..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, _vm._l((_vm.services), function(service) {
    return _c('div', {
      staticClass: "service"
    }, [_c('img', {
      attrs: {
        "src": '/dist/' + service.icon
      }
    }), _vm._v(" "), _c('h3', {
      staticClass: "two-line-heading",
      domProps: {
        "innerHTML": _vm._s(service.title)
      }
    }, [_vm._v(">")]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(service.text))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f329e86","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/iam.vue
// module id = 151
// module chunks = 0